import React from 'react';
import './TeamSection.css';

const teamCards = [
  {
    logo: '/logos/frontend.webp',
    title: 'FRONTEND AND BACKEND DEVELOPERS',
    desc: 'From React, Flask, Django to Node and Ruby on Rails developers, we have a great talent-pool of web & software developers with a high technical expertise to develop complex web based applications, with several levels of seniority, from Regular, Senior to Technical Leads.',
  },
  {
    logo: '/logos/designer.webp',
    title: 'DESIGNERS',
    desc: 'Our award-winning designers and developers work side-by-side to create superior UX/UI experiences for your web development project, using leading tools such as Webflow.',
  },
  {
    logo: '/logos/manager.webp',
    title: 'Project Managers',
    desc: 'Drawing on experience in industries galore, our Project Managers define project requirements and outline the scope of a future web app. After that, they provide a high-level project plan, give rough time estimates, and compile a team for your web project implementation.',
  },
  {
    logo: '/logos/scientist.webp',
    title: 'DATA SCIENTISTS',
    desc: 'By following a technology-agnostic process, our Data Scientists design Artificial Intelligence systems through incremental development, using a scrum-based methodology. The aim is to help companies like yours automate business, make better decisions, forecast future patterns or trends, and build competitive advantage.',
  },
  {
    logo: '/logos/devops.webp',
    title: 'DEVOPS ENGINEERS',
    desc: 'Improve your products development lifecycle with our DevOps Engineers expertise in CI/CD pipelines, infrastructure as code, and advanced monitoring systems. They ensure seamless integration and continuous delivery, enhancing system reliability and optimizing deployment processes for efficiency and scalability',
  },
  {
    logo: '/logos/arcitect.webp',
    title: 'SOLUTIONS ARCHITECTS',
    desc: 'Our Solutions Architects leverage deep technical knowledge and industry experience to design scalable, secure, and cost-effective architectures, driving your strategic objectives and long-term vision.',
  },
  {
    logo: '/logos/specialist.webp',
    title: 'QUALITY ASSURANCE SPECIALIST',
    desc: 'Ensure unparalleled software quality through rigorous testing methodologies. Our QA Specialists employ both automated and manual testing techniques to detect and resolve issues early, guaranteeing that your product is reliable, high-performing, and user-centric.',
  },
];

const TeamSection = () => {
  return (
    <section className="team-section" id = "team">
      <div className="container">
      <div className="team-intro">
        <div className="team-left">
          <h2>OUR <span className="avatar">TEAM</span></h2>
          <p>
            With a recommendation rate of 99%, Imaginary Cloud has over 100 passionate, EU-based professionals who seamlessly align your business goals with cutting-edge digital technologies, driving a journey of digital transformation, acceleration and productization.<br></br><br></br>

Renowned for our expertise in processes that ensure top-notch quality delivery, our dedicated team of web developers, designers, project managers, and data scientists possesses the technical knowledge, creativity, and vision required to craft exquisite, intelligent web and app software products.
          </p>
        </div>
        <div className="team-right">
          <img src="/team.webp" alt="Team" />
        </div>
      </div>

      <div className="team-cards">
        {teamCards.map((card, index) => (
          <div key={index} className="team-card">
            <div className="card-header">
              <img src={card.logo} alt={card.title} />
              <h3>{card.title}</h3>
            </div>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
};

export default TeamSection;
